import { ApiResponse, DecisionCriteriaLog } from '@/models';
import BaseService from '@/utils/base-service';

export class DecisionCriteriaLogService extends BaseService {
    private endpoint = '/DecisionModel/DecisionCriteriaLog';

    constructor() {
        super(process.env.VUE_APP_API_BASE_URL);
    }
    public async get(sno: number): Promise<ApiResponse<DecisionCriteriaLog>> {
        return (await this.api.get(`${this.endpoint}/${sno}`)).data;
    }
}
